export enum MercerValidationState {
  Open = 'Open',
  Requested = 'Requested',
  Accepted = 'Accepted',
  Published = 'Published',
  Rejected = 'Rejected',
  RequestedCb = 'RequestedCb'
}
